"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UndoSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var UndoSVG = function UndoSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M5,2A1,1,0,0,1,6,3v8.272L12.64,4.636A9,9,0,0,1,25.368,17.364L13.025,29.707a1,1,0,0,1-1.414-1.414L23.954,15.95a7,7,0,0,0-9.9-9.9L7.105,13H16a1,1,0,0,1,0,2H5.5A1.5,1.5,0,0,1,4,13.5V3A1,1,0,0,1,5,2Z"
  }));
};
exports.UndoSVG = UndoSVG;
UndoSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(UndoSVG);
exports.default = _default;